import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { DataService } from '../services/data-service';
import { ROUTE_BREADCRUMB_MAP } from '../shared/constants/breadcrumb.constant';


export const routeManagementGuard: CanActivateFn = (route, state) => {
  const dataService = inject(DataService);
  const cleanUrl = state.url.split('?')[0].replace(/\/\d+$/, '');
  let breadcrumb = ROUTE_BREADCRUMB_MAP[cleanUrl];
  if (!breadcrumb) {
    const matchedKey = Object.keys(ROUTE_BREADCRUMB_MAP)
      .filter((key) => cleanUrl.startsWith(key))
      .sort((a, b) => b.length - a.length)[0];
    breadcrumb = matchedKey ? ROUTE_BREADCRUMB_MAP[matchedKey] : [];
  }
  dataService.setBreadcrumb(breadcrumb);
  return true;
};
